import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-47c0266e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "modal-mask"
}
const _hoisted_2 = { class: "modal-wrapper" }
const _hoisted_3 = { class: "modal-container" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "Search for the artist you'd like to add.")
], -1))
const _hoisted_5 = { class: "modal-body" }
const _hoisted_6 = ["value"]
const _hoisted_7 = { class: "modal-footer" }
const _hoisted_8 = { class: "data-container" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "info" }, " If the artist you are searching for is not listed, please go to Add Artist. If you would like to edit the spelling of the name of an existing artist, please contact Artscoops’ team ", -1))
const _hoisted_10 = ["disabled", "onClick"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Didn't find who you're looking for ?", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Transition, { name: "modal" }, {
    default: _withCtx(() => [
      (_ctx.show)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("button", {
                  class: "modal-default-button",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
                }, " x "),
                _hoisted_4,
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("input", {
                    type: "text",
                    placeholder: "Artist name",
                    value: _ctx.search,
                    onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.updateSearch && _ctx.updateSearch(...args)))
                  }, null, 40, _hoisted_6)
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("button", {
                    class: "btn",
                    type: "button",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.searchArtists(_ctx.search)))
                  }, " SEARCH ")
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _hoisted_9,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allArtists, (artist) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "artists-list",
                      key: artist.id
                    }, [
                      _createElementVNode("span", null, _toDisplayString(artist.full_name), 1),
                      (_ctx.isPrivateSeller || _ctx.galleryArtists)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            disabled: _ctx.isArtistInGallery(artist),
                            onClick: ($event: any) => (_ctx.addArtist(artist.id))
                          }, " ADD ", 8, _hoisted_10))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128)),
                  _createElementVNode("div", null, [
                    _hoisted_11,
                    _createElementVNode("button", {
                      class: "btn",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$router.push('artists/new')))
                    }, " ADD NEW ARTIST ")
                  ])
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}